import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import styles from "./ContentModal.module.scss";

const ContentModal = ({ contentId, isOpen, onClose, getContentTitle, renderContent }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const modalContent = (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{getContentTitle(contentId)}</h2>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            <i className="tg-icons-Close"></i>
          </button>
        </div>
        <div className={styles.modalContent}>{renderContent(contentId)}</div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

ContentModal.propTypes = {
  contentId: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  getContentTitle: PropTypes.func.isRequired,
  renderContent: PropTypes.func.isRequired,
};

export default ContentModal;
